import { render, staticRenderFns } from "./SkinLayout.vue?vue&type=template&id=3a1974f0&"
import script from "./SkinLayout.vue?vue&type=script&lang=js&"
export * from "./SkinLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports